import * as fragments from './fragments'

export const Fragments = {
  ...fragments
}
